import { ArrowUpRight } from "lucide-react";
import CardServicos from "./cardServicos";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "./carousel";

export default function MigracaoBeneficios({ servicosData, title }) {
    const { openModal } = useModal();
    return (
        <div className="w-full bg-[url(../assets/cover-migracao-beneficios.png)] bg-cover bg-top py-20 relative overflow-hidden text-white">
            <div className="max-w-[1200px] mx-auto relative z-10 px-4 md:px-8">
                <h2 className="font-inter-regular text-5xl md:text-[60px] text-center mb-12">
                    {title}
                </h2>
                <div className="relative mx-[-1rem] md:mx-[-2rem]">
                    <Carousel className="overflow-visible">
                        <div className="flex justify-end absolute right-8 md:right-16 top-6 z-10">
                            <CarouselPrevious className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
                            <CarouselNext className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
                        </div>
                        <CarouselContent className="py-8 px-6 md:px-8">
                            {servicosData.map((servico, index) => (
                                <CarouselItem
                                    key={index}
                                    className="basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/3 pl-4 md:pl-6"
                                >
                                    <div className="relative overflow-visible px-2">
                                        <CardServicos 
                                            {...servico} 
                                            height={380}
                                        />
                                    </div>
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                    </Carousel>
                    <div className="relative ps-[2px] py-[2px] pe-px rounded-[30px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-fit mx-auto md:ml-16 mt-10 md:-mt-8">
                        <div className="flex items-center gap-8 bg-[#2B283D] px-6 py-3.5 rounded-[30px] text-white w-[350px]">
                            <h3 className="w-fit font-inter-light">
                                Otimize seu <br /> negócio!
                            </h3>
                            <button
                                onClick={() => openModal(<FormularioRD />)}
                                className="w-fit bg-white text-black text-sm font-inter-light flex items-center m-auto gap-2 py-2 px-10 rounded-full cursor-pointer hover:scale-105 transition-all duration-300"
                            >
                                Contratar <ArrowUpRight className="size-5" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
